<template>
  <div class="container">
    <Header show-left title="登录"></Header>
    <Tabs class="clear-bg van-hairline--bottom tabs-font" :tabsItems="tabsItems" striped v-model="activeIndex"></Tabs>
    <Scroll>
      <VForm ref="form" v-model="formValid" :model="params" :rules="rules" @submit="submit">
        <FormItem name="tel">
          <van-field label="手机号" name='tel' v-model="params.tel" placeholder="请输入手机号" type="tel"/>
        </FormItem>
        <FormItem name="sms" v-if="activeIndex[0]===0">
          <van-field center v-model="params.sms" label="验证码" name='sms' placeholder="请输入验证码">
            <van-button tag="span" slot="button" size="small" type="danger" :disabled="codeBtnStatus"
                        @click="showDialog">{{codeStr}}
            </van-button>
          </van-field>
        </FormItem>
        <FormItem name="password" v-else>
          <van-field label="密码" name='password' v-model="params.password" placeholder="请输入密码" type="password"/>
        </FormItem>
        <div class="padding">
          <van-button type="submit" block size="danger" :disabled="!formValid">登录</van-button>
        </div>
      </VForm>
    </Scroll>
    <Dialog :showModal="dialogShow" @click="dialogFn" title="这里是标题" label="这里是内容描述">
      <h2>请输入图片中验证码</h2>
      <div class="code-wrap">
        <div class="input-wrap">
          <input type="number" v-model="picValidateCode" placeholder="请输入验证码">
        </div>
        <img :src="`https://demo.tijianzhuanjia.com/wx/validationCode.jpg?r=${timestamp}`" @click="updateCode"/>
      </div>
      <div class="error assertive text-left" v-if="codeError">验证码错误</div>
    </Dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Field, Button } from 'vant'
import { Header, Tabs, Scroll, VForm, FormItem, Dialog } from '@/components/common'
import { PATTERN, Location, uuid } from '@/assets/scripts/helper'
import { LOGIN, MESSAGE_CODE } from '@/assets/scripts/api'
import Cookies from 'js-cookie'

Vue.use(Button).use(Field)

export default {
  data () {
    return {
      dialogShow: false,
      error: '',
      activeIndex: [0],
      picValidateCode: '',
      formValid: false,
      timestamp: new Date().getTime(),
      codeStr: '获取验证码',
      codeError: false,
      timer: null,
      rules: {
        tel: PATTERN.TEL,
        sms: PATTERN.SMS,
        password: PATTERN.PASSWORD
      },
      params: {
        tel: Cookies.get('51jk.USER'),
        sms: '',
        password: ''
      },
      tabsItems: [{
        title: '短信登录'
      }, {
        title: '密码登录'
      }]
    }
  },
  computed: {
    codeBtnStatus () {
      return !!(!this.rules.tel.rule.test(this.params.tel) || this.timer)
    }
  },
  methods: {
    showDialog () {
      this.dialogShow = true
      this.codeError = false
      this.picValidateCode = ''
    },
    dialogFn (e) {
      if (e) {
        if (this.picValidateCode.length === 4) {
          this.$axios.post(MESSAGE_CODE, {
            _BIZCODE: '0002',
            mobilePhone: this.params.tel,
            picValidateCode: this.picValidateCode
          }).then(response => {
            let {data} = response
            if (!data.error) {
              let countDown = 59
              this.timer = setInterval(() => {
                if (countDown > 0) {
                  countDown--
                  this.codeStr = `已发送(${countDown})`
                } else {
                  this.codeStr = '重新发送'
                  clearInterval(this.timer)
                  this.timer = null
                }
              }, 1000)
            }
          })
        } else {
          this.codeError = true
          return
        }
      }
      this.dialogShow = false
    },
    updateCode () {
      this.timestamp = new Date().getTime()
    },
    submit () {
      let params = {openid: Cookies.get('51jk.qOpenid') || undefined}
      if (this.activeIndex[0] === 1) {
        params = {
          username: this.params.tel,
          password: this.params.password
        }
      } else {
        params = {
          loginType: '1',
          mobilePhone: this.params.tel,
          msgCode: this.params.sms
        }
      }
      Cookies.set('51jk.CID', uuid())
      this.$axios.post(LOGIN, params).then(response => {
        let {token} = response.data
        Cookies.set('51jk.TK', token)
        Cookies.set('51jk.USER', this.params.tel)
        this.$store.commit('user/deleteSelf')
        this.$store.dispatch('user/getUserData')
        let {path} = this.$route.query
        if (path) {
          Location(path, true)
        } else {
          this.$router.go(-1)
        }
      })
    }
  },
  components: {
    Header,
    Tabs,
    Scroll,
    VForm,
    FormItem,
    Dialog
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.content {
  background: $light;
}

.padding {
  padding: 25px 15px;
}

.code-wrap {
  display: flex;
  padding: 20px 0 10px;
  overflow: hidden;
  .input-wrap {
    padding-right: 15px;
    flex: 1;
  }
  input {
    border-radius: 3px;
    border: 1PX solid $gray;
    height: 40px;
    padding: 5px;
    width: 100%;
  }
  img {
    width: 120px;
    height: 40px;
    display: block;
  }
}

.tabs-font {
  font-size: 16px;
}

</style>
